import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './styles.css';
import { renderGroupIcon } from './icons';
var TITLES = {
  addresses: 'Адреса',
  cities: 'Город',
  districts: 'Район',
  newbuildings: 'Жилые комплексы',
  shoppingCenters: 'Торговые центры',
  businessCenters: 'Бизнес-центры',
  undergrounds: 'Метро',
  railways: 'Ж/Д станции',
  villages: 'Коттеджные поселки',
  roads: 'Шоссе',
  builders: 'Застройщики',
  coworkings: 'Коворкинги'
};
var TITLE_STYLES = {
  addresses: styles['addresses'],
  cities: styles['cities'],
  districts: styles['districts'],
  newbuildings: styles['newbuildings'],
  shoppingCenters: styles['shop'],
  businessCenters: styles['business'],
  undergrounds: styles['undergrounds'],
  railways: styles['railways'],
  villages: styles['villages'],
  roads: styles['roads'],
  builders: styles['builders'],
  coworkings: styles['coworkings']
};
export var SuggestionsGroup = function SuggestionsGroup(props) {
  var name = props.name;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['group-container'],
    "data-group": name
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement("i", mergeStyles(TITLE_STYLES[name], styles['group-logo']), renderGroupIcon(name)), TITLES[name]), props.children));
};